export default __webpack_public_path__ + "static/media/p4-4.36db91c1.png";